import { Typography } from "@mui/material";
import { useMemo } from "react";

import HNSColors from "../../../../ui library/HNSColors";

const Header = ({ maxDocSize, supportedFiles, isEditing, title }) => {
  const renderTitle = useMemo(() => {
    if (title) {
      return title;
    }
    return isEditing ? "Edit Document" : "Upload Document To Case";
  }, [title, isEditing]);

  return (
    <>
      <div className="w-full items-center" data-testid="container-title">
        <Typography className="w-full text-[1.5rem] font-bold" color={HNSColors.primary[500]}>
          {renderTitle}
        </Typography>
      </div>

      <p className="text-xs text-slate-400">
        {maxDocSize} &nbsp;|&nbsp; Supported File Extensions -{" "}
        {!supportedFiles ? "Select a Document Type to View" : supportedFiles}
      </p>
    </>
  );
};

export default Header;
